.fp-vertical-spacing(data-test='other-programs')
  .fp-vertical-spacing--line
    h2.fp-title {{ t('programs.page.otherPrograms') }}
  .fp-vertical-spacing--line
    ProgramsCarouselVue(:programs='otherPrograms')
